
import { Route, Routes } from "react-router-dom";
import PublicSiteLayout from "./layouts/PublicSiteLayout";
import LandingPage from "./pages/Landing/LandingPage";
import FreeTrialRequest from "./pages/FreeTrial/FreeTrialRequest";
import PublicLegalPage from "./pages/LegalPages/PublicLegalPage";

export default function App() {
  return (
    <Routes>
      <Route element={<PublicSiteLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/free-trial" element={<FreeTrialRequest />} />
        <Route path="/mentions-legales" element={<PublicLegalPage slug="mentions-legales" />} />
        <Route path="/confidentialite" element={<PublicLegalPage slug="confidentialite" />} />
        <Route path="/cookies" element={<PublicLegalPage slug="cookies" />} />
        <Route path="/cgu" element={<PublicLegalPage slug="cgu" />} />
        <Route path="/cgv" element={<PublicLegalPage slug="cgv" />} />
        <Route path="/annulation-remboursement" element={<PublicLegalPage slug="annulation-remboursement" />} />
        <Route path="/contact" element={<PublicLegalPage slug="contact" />} />
      </Route>
    </Routes>
  );
}
